import { makeStyles } from '@material-ui/core';

export const articleStyles = makeStyles((theme) => ({
  linkSubheader: {
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
  container: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  divider: {
    height: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
    backgroundColor: theme.palette.secondary.main,
  },
  dividerSubtitle: {
    height: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
    backgroundColor: theme.palette.common.black,
  },
  articleDetailsTags: {
    marginRight: theme.spacing(1),
  },
  link: {
    color: theme.palette.secondary.main,
  },
  contentImage: {
    height: '25em',
    width: '100% !important',
    [theme.breakpoints.down('xs')]: {
      height: '16em',
      objectFit: 'contain',
    },
  },
  contentVideo: {
    border: '10px solid black',
    borderRadius: '10px',
    backgroundColor: 'black',
  },
  payWallSpacer: {
    height: '52vh',
    boxSizing: 'border-box',
    overflow: 'hidden',
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      height: '64vh',
      paddingTop: theme.spacing(1.5),
    },
  },
  payWallArticlePreview: {
    maxWidth: '47.5rem',
    color: theme.palette.text.primary,
    filter: 'blur(6px)',
    WebkitFilter: 'blur(6px)',
    opacity: 0.52,
    pointerEvents: 'none',
    userSelect: 'none',
    textAlign: 'left',
    '& p': {
      marginBottom: theme.spacing(2),
      lineHeight: 1.85,
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
      filter: 'blur(5px)',
      WebkitFilter: 'blur(5px)',
    },
  },
  payWall: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    width: '100vw',
    minHeight: '52vh',
    boxSizing: 'border-box',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4, 2, 5),
    background:
      'linear-gradient(180deg, #faf8f5 0%, #f5f1ed 45%, #efe7df 100%)',
    zIndex: theme.zIndex.drawer - 1,
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: theme.spacing(14),
      background:
        'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,245,241,0) 100%)',
      pointerEvents: 'none',
    },
    [theme.breakpoints.down('xs')]: {
      minHeight: '64vh',
      padding: theme.spacing(4, 2, 6),
    },
  },
  payWallContent: {
    width: '100%',
    maxWidth: '47.5rem',
    textAlign: 'center',
    backgroundColor: 'transparent',
    padding: theme.spacing(0, 3),
    color: theme.palette.text.primary,
    position: 'relative',
    zIndex: 1,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      padding: 0,
    },
  },
  payWallHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  payWallCards: {
    marginTop: theme.spacing(2),
    justifyContent: 'center',
  },
  payWallCard: {
    height: '100%',
    maxWidth: '22rem',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
  },
  payWallBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(0.5, 1.5),
    borderRadius: 999,
    color: theme.palette.secondary.main,
    backgroundColor: 'rgba(245, 124, 0, 0.12)',
    fontWeight: theme.typography.fontWeightBold as number,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    fontSize: theme.typography.caption.fontSize,
  },
  payWallButton: {
    fontWeight: theme.typography.fontWeightBold as number,
    color: theme.palette.secondary.contrastText,
  },
  payWallOutlineButton: {
    fontWeight: theme.typography.fontWeightBold as number,
    backgroundColor: theme.palette.common.white,
  },
  containerComments: {
    padding: theme.spacing(2, 0),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
    },
  },
  commentsContent: {
    padding: theme.spacing(2, 0),
  },
  threadContent: {
    marginLeft: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    borderLeft: '1px solid #d3d3d3',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(8),
      paddingLeft: theme.spacing(2),
    },
  },
  authorName: {
    fontWeight: theme.typography.fontWeightBold as number,
    textDecoration: 'none',
    color: theme.palette.primary.main,
  },
}));
